import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import TaskView from '@/views/TaskView';
import MyTasks from '@/views/MyTasks';


export default createRouter({
  history: window.APP_TRON ? createWebHashHistory() : createWebHistory(),
  mode: window.APP_TRON ? 'hash' : 'history',
  base: window.APP_TRON ? undefined : process.env.BASE_URL,
  routes: [
    {
      path: '/project',
      redirect: '/project/last/Last',
    },
    {
      path: '/project/last',
      redirect: '/project/last/Last',
    },
    {
      path: '',
      redirect: '/project/last/Last',
    },
    {
      path: '/project/:projectSlug/:slugNameProject',
      name: 'project',
      component: () => import(/* webpackChunkName: "Project" */ '@/views/Project'),
      children: [
        {
          path: ':hid+/:taskSlug/:slugNameTask',
          name: 'projectTask',
          component: TaskView, // Use static import
        },
        {
          path: 'settings',
          name: 'projectSettings',
          component: () => import(/* webpackChunkName: "projectSettings" */ '@/views/ProjectSettings'),

        },
        {
          path: 'my-tasks',
          name: 'myTasks',
          component: MyTasks, // Use static import
        },
        {
          path: 'task-history',
          name: 'taskHistory',
          component: () => import(/* webpackChunkName: "TaskHistory" */ '@/views/TaskHistory'),
        },
        {
          path: 'integrations',
          name: 'projectIntegrations',
          component: () => import(/* webpackChunkName: "ProjectIntegrations" */ '@/views/ProjectIntegrations'),
        },
      ],
    },
    {
      path: '/tasks-time-spent/',
      name: 'tasks-time-spent',
      component: () => import(/* webpackChunkName: "TaskTimeSpentWrapper" */ '@/views/reports/TaskTimeSpentWrapper'),
      children: [
        {
          path: 'invoice-generator',
          name: 'invoice-generator',
          component: () => import(/* webpackChunkName: "InvoiceGeneratorNext" */ '@/views/InvoiceGeneratorNext'),
        },
      ],
    },
    {
      path: '/salary/:salary_project_id',
      name: 'salary',
      component: () => import(/* webpackChunkName: "Salary" */ '@/views/Salary'),
    },
    {
      path: '/dayoff',
      name: 'dayoff',
      component: () => import(/* webpackChunkName: "Salary" */ '@/views/Dayoff'),
      meta: { title: 'menu.dayoff' },
    },
    {
      path: '/profit-share/:profit_share_project_id',
      name: 'profit-share',
      component: () => import(/* webpackChunkName: "ProfitShare" */ '@/views/ProfitShare'),
      meta: { title: 'menu.profit_share' },
    },
    {
      path: '/workspace-summary/',
      name: 'workspace-summary',
      component: () => import(/* webpackChunkName: "WorkspaceSummaryWrapper" */ '@/views/reports/WorkspaceSummaryWrapper'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'page-not-found',
      component: () => import(/* webpackChunkName: "PageNotFound" */ '@/views/PageNotFound'),
    },
    {
      path: '/access-denied/',
      name: 'access-denied',
      component: () => import(/* webpackChunkName: "AccessDenied" */ '@/views/AccessDenied'),
    },
    {
      path: '/run-app/',
      name: 'runApp',
      component: () => import(/* webpackChunkName: "AppRunner" */ '@/views/AppRunner'),
    },
    {
      path: '/create-project/',
      name: 'createProject',
      component: () => import(/* webpackChunkName: "CreateProject" */ '@/views/CreateProject'),
    },
    {
      path: '/workspace-settings/',
      name: 'workspaceSettings',
      component: () => import(/* webpackChunkName: "WorkspaceSettings" */ '@/views/WorkspaceSettings'),
    },
    {
      path: '/profile-settings/',
      name: 'profileSettings',
      component: () => import(/* webpackChunkName: "ProfileSettings" */ '@/views/ProfileSettings'),
    },
    {
      path: '/get-app/',
      name: 'getApp',
      component: () => import(/* webpackChunkName: "AppDownload" */ '@/views/AppDownload'),
    },
    {
      path: '/ai-automation/',
      name: 'aiAutomation',
      component: () => import(/* webpackChunkName: "AiAutomation" */ '@/views/AiAutomation'),
      meta: { title: 'menu.ai_automation' },
    },
    {
      path: '/mcp-authorize/',
      name: 'mcpAuthorize',
      component: () => import(/* webpackChunkName: "McpAuthorize" */ '@/views/McpAuthorize'),
    },
    ...(window.APP_TRON ? [
      {
        path: '/approveWindow',
        name: 'approveWindow',
        component: () => import(/* webpackChunkName: "approveWindow" */ '@/views/popups/approveWindow'),
      },
      {
        path: '/notifyWindow',
        name: 'notifyWindow',
        component: () => import(/* webpackChunkName: "notifyWindow" */ '@/views/popups/notifyWindow'),
      },
      {
        path: '/taskNotifyWindow',
        name: 'taskNotifyWindow',
        component: () => import(/* webpackChunkName: "taskNotifyWindow" */ '@/views/popups/taskNotifyWindow'),
      },
      {
        path: '/notifyDownTime',
        name: 'notifyDownTime',
        component: () => import(/* webpackChunkName: "notifyDownTime" */ '@/views/popups/notifyDownTime'),
      },
      {
        path: '/resumeWindow',
        name: 'resumeWindow',
        component: () => import(/* webpackChunkName: "resumeWindow" */ '@/views/popups/resumeWindow'),
      },
    ] : []),
  ],
});
